import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { Button, Checkbox } from '@repo/ui';

import { MODAL_STATE, useModalStore } from '@/components/modal/modal.store';
import { PrivacyDetails } from '@/components/welcome/components/privacy-details';

export const P24MarketingAgreementsFormInputs = () => {
  const { t } = useTranslation();
  const { openModal } = useModalStore();
  const context = useFormContext();

  const { email: emailValue, tel: telValue, sms: smsValue } = context.watch();

  const isAllCheckboxesSelected = [smsValue, telValue, emailValue].every(Boolean);

  const onToggleAllPermissions = () => {
    const nextValue = !isAllCheckboxesSelected;
    context.setValue('email', nextValue);
    context.setValue('tel', nextValue);
    context.setValue('sms', nextValue);
  };

  return (
    <Box>
      <Typography
        fontSize={{ xs: 10, sm: 12, md: 11 }}
        lineHeight={{ xs: '13px', sm: '16px', md: '18px' }}
      >
        {t('welcomePage.p24MarketingForm.description')}
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 0, sm: 2 }}>
        <Checkbox
          label={t('welcomePage.p24MarketingForm.fields.selectAll')}
          checked={isAllCheckboxesSelected}
          name="selectAllP24MarketingAgreementsCheckbox"
          onChange={onToggleAllPermissions}
          labelProps={{
            sx: { fontSize: 11 },
          }}
        />

        <Checkbox
          label={t('welcomePage.p24MarketingForm.fields.email')}
          name="email"
          labelProps={{
            sx: { fontSize: 11 },
          }}
        />

        <Checkbox
          label={t('welcomePage.p24MarketingForm.fields.sms')}
          name="sms"
          labelProps={{
            sx: { fontSize: 11 },
          }}
        />

        <Checkbox
          label={t('welcomePage.p24MarketingForm.fields.phone')}
          name="tel"
          labelProps={{
            sx: { fontSize: 11 },
          }}
        />
      </Stack>
      <Box>
        <Typography component="p" fontSize={11}>
          {t('welcomePage.p24MarketingForm.agreementCancellation')}
        </Typography>
        <Typography variant="subtitle3">
          {t('welcomePage.p24MarketingForm.administratorInfo')}
        </Typography>
        <Button
          base
          onClick={() => {
            openModal(MODAL_STATE.LOAN_AGREEMENTS, <PrivacyDetails />);
          }}
        >
          <Typography component="span" variant="subtitle3" fontWeight={600}>
            {t('welcomePage.p24MarketingForm.readMore')}
          </Typography>
        </Button>
      </Box>
    </Box>
  );
};
